'use client';

import { PropsWithChildren } from 'react';
import { StableTimestamp } from '@/providers/stable-timestamp.provider';

export function BaseProviders({ children }: PropsWithChildren) {
  return <StableTimestamp.Base>{children}</StableTimestamp.Base>;
}
